//Actions
const PURGE = "organization/PURGE";
const SET_ORGANIZATION_DATA = "organization/SET_ORGANIZATION_DATA";
const SET_USER_TOKEN = "organization/SET_USER_TOKEN";
const SET_ACCESS_TOKEN = "organization/SET_ACCESS_TOKEN";
const SET_REFRESH_TOKEN = "organization/SET_REFRESH_TOKEN";
const SET_USER_DATA = "organization/SET_USER_DATA";
const SET_VS_CDN = "organization/SET_VS_CDN";
const SET_CDN = "organization/SET_CDN";

// 액션 생성 함수
export const purgeOrganiztion = () => ({ type: PURGE });
export const setOrganizationData = organizationData => ({ type: SET_ORGANIZATION_DATA, organizationData });
export const setUserToken = userToken => ({ type: SET_USER_TOKEN, userToken });
export const setAccessToken = accessToken => ({ type: SET_ACCESS_TOKEN, accessToken });
export const setRefreshToken = refreshToken => ({ type: SET_REFRESH_TOKEN, refreshToken });
export const setUserData = userData => ({ type: SET_USER_DATA, userData });
export const setVsCdn = VSCdn => ({ type: SET_VS_CDN, VSCdn });
export const setCdn = cdn => ({ type: SET_CDN, cdn });

// 초깃값 (상태가 객체가 아니라 그냥 숫자여도 상관 없습니다.)
const initialState = {
  organizationList: [],
  organizationData: {},
  userToken: '',
  accessToken: '',
  refreshToken: '',
  userData: {},
  VSCdn: '',
  cdn: ''
};

export default function organization(state = initialState, action) {
  switch (action.type) {
    case PURGE: // 받아왔던 기관 리스트는 남겨준다.
      return {
        ...initialState
      }
    case SET_ORGANIZATION_DATA:
      return {
        ...state,
        organizationData: action.organizationData
      }
    case SET_USER_TOKEN:
      return {
        ...state,
        userToken: action.userToken
      };
    case SET_ACCESS_TOKEN:
      return {
        ...state,
        accessToken: action.accessToken
      };
    case SET_REFRESH_TOKEN:
      return {
        ...state,
        refreshToken: action.refreshToken
      };
    case SET_USER_DATA:
      return {
        ...state,
        userData: action.userData
      };
    case SET_VS_CDN:
      return {
        ...state,
        VSCdn: action.VSCdn
      };
    case SET_CDN:
      return {
        ...state,
        cdn: action.cdn
      };
    default:
      return state;
  }
} 